<template>
  <div class="dept_container">
    <div class="department_title">
      组织查询
    </div>
    <el-form :inline="true" :model="formInline" class="demo-form-inline">
      <el-form-item label="组织名称：">
        <el-input
          v-model="formInline.deptName"
          placeholder="请输入组织名称"
          clearable
        ></el-input>
      </el-form-item>

      <el-form-item class="left_margin">
        <el-button type="primary" @click="onSubmit" class="inquire"
          >搜索</el-button
        >
        <el-button type="primary" class="reset" @click="reset">重置</el-button>
      </el-form-item>
    </el-form>
    <div class="newly_built">
      <el-button
        type="primary"
        icon="el-icon-plus"
        class="newly_built_btn"
        @click="handleAdd"
        v-if="premission('system:dept:add')"
        >新建组织</el-button
      >
    </div>

    <el-table
      :data="tableData"
      style="width: 100%"
      row-key="deptId"
      :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
    >
      <el-table-column prop="deptName" label="组织名称" width="280">
      </el-table-column>
      <el-table-column prop="deptNickname" label="组织简称" width="180">
      </el-table-column>
      <el-table-column label="属性" width="180">
        <template slot-scope="scope">
          <div v-if="scope.row.level == 0">部门</div>
          <div v-if="scope.row.level == 1">公司</div>
        </template>
      </el-table-column>
      <el-table-column prop="orderNum" label="排序" width="90">
      </el-table-column>
      <el-table-column prop="createBy" label="修改人" width="90">
      </el-table-column>
      <el-table-column prop="createTime" label="修改日期" width="180">
      </el-table-column>
      <el-table-column label="是否显示" width="180">
        <template slot-scope="scope">
          <el-switch
            v-model="scope.row.status"
            active-color="#F6B439"
            inactive-color="#ff4949"
            active-value="0"
            inactive-value="1"
            @change="switch_value_btn(scope.row)"
          >
          </el-switch>
        </template>
      </el-table-column>

      <el-table-column prop="address" label="操作">
        <template slot-scope="scope">
          <el-button
            type="text"
            class="operation_right"
            icon="el-icon-plus"
            @click="handleAdd(scope.row)"
            v-if="premission('system:dept:add')"
            >新建组织</el-button
          >
          <el-button
            type="text"
            class="operation_right"
            icon="el-icon-edit-outline"
            @click="compile(scope.row)"
            v-if="premission('system:dept:edit')"
            >编辑</el-button
          >
          <el-button
            type="text"
            icon="el-icon-delete"
            @click="Delete(scope.row)"
            v-if="premission('system:dept:remove')"
            >删除</el-button
          >
        </template>
      </el-table-column>
    </el-table>

    <!-- 新增组织弹窗 -->
    <el-dialog
      :title="this.title"
      :visible.sync="dialogVisible"
      width="600px"
      :before-close="handleClose"
    >
      <el-form
        ref="form"
        :rules="rules"
        :model="sizeForm"
        label-width="110px"
        size="mini"
      >
        <el-form-item label="上级组织：" prop="parentId">
          <treeselect
            v-model="sizeForm.parentId"
            :options="deptOptions"
            :normalizer="normalizer"
            placeholder="请选择上级组织名称"
          />
        </el-form-item>
        <el-form-item label="组织名称：" prop="deptName">
          <el-input
            v-model="sizeForm.deptName"
            placeholder="请填写新建组织名称"
          ></el-input>
        </el-form-item>
        <el-form-item label="组织简称：">
          <el-input
            v-model="sizeForm.deptNickname"
            placeholder="请输入组织简称,无则不填"
          ></el-input>
        </el-form-item>

        <el-form-item label="本级排序：" prop="orderNum">
          <el-input
            v-model="sizeForm.orderNum"
            placeholder="该组织在本级别中的显示排序，数字越小越靠前"
          ></el-input>
        </el-form-item>
        <el-form-item label="组织类型：">
          <el-radio v-model="sizeForm.level" label="1">公司</el-radio>
          <el-radio v-model="sizeForm.level" label="0">部门</el-radio>
        </el-form-item>
        <el-form-item label="是否显示：">
          <el-radio v-model="sizeForm.status" label="0">显示</el-radio>
          <el-radio v-model="sizeForm.status" label="1">不显示</el-radio>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="cancelDataScope" class="cancel">取 消</el-button>
        <el-button type="primary" @click="add_new_btn" class="add_new_btn"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import premission from "../../utils/permission";
import { handleTree } from "../../utils/treating";
import {
  DeptchangeStatus,
  DeptListsAjax,
  DeptDeleteAjax,
  addDept,
  getDept,
  updateDept
} from "../../api/index";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
export default {
  components: { Treeselect },
  mixins: [premission],
  data() {
    return {
      // 节流阀
      throttle: "true",
      // 新建组织弹窗
      dialogVisible: false,
      //是否显示
      // switch_value: false,
      // 搜索数据
      formInline: {
        deptName: "",
        status: ""
      },
      // 新建组织数据
      sizeForm: {
        parentId: "",
        deptNickname: "",
        deptName: "",
        orderNum: "",
        level: "0",
        status: "0"
      },
      // 表单数据
      tableData: [],
      // 组织树选项
      deptOptions: [],
      // 弹出层标题
      title: "",
      // 表单校验
      rules: {
        parentId: [
          { required: true, message: "上级组织不能为空", trigger: "blur" }
        ],
        deptName: [
          { required: true, message: "组织名称不能为空", trigger: "blur" }
        ],
        orderNum: [
          { required: true, message: "本级排序不能为空", trigger: "blur" }
        ]
      }
    };
  },
  created() {
    this.getDeptListsAjax();
  },
  methods: {
    //搜索
    async onSubmit() {
      if (!this.throttle) return;
      this.throttle = false;
      const { data: res } = await DeptListsAjax(this.formInline);
      if (res.code !== 200)
        return this.$message({
          message: res.msg,
          type: "error"
        });
      this.throttle = true;
      this.tableData = handleTree(res.data, "deptId");
    },
    // 重置
    reset() {
      this.getDeptListsAjax();
      this.formInline.status = "";
      this.formInline.deptName = "";
    },
    /** 转换组织数据结构 */
    normalizer(node) {
      if (node.children && !node.children.length) {
        delete node.children;
      }
      return {
        id: node.deptId,
        label: node.deptName,
        children: node.children
      };
    },
    // 获取表单数据
    async getDeptListsAjax() {
      const { data: res } = await DeptListsAjax();
      if (res.code !== 200)
        return this.$message({
          message: res.msg,
          type: "error"
        });
      this.tableData = handleTree(res.data, "deptId");
    },
    // 新增按钮操作
    async handleAdd(row) {
      if (row != undefined) {
        this.sizeForm.parentId = row.deptId;
      }
      this.dialogVisible = true;
      this.title = "新建组织";
      this.deptOptions = this.tableData;
    },
    // 编辑按钮
    async compile(row) {
      this.title = "编辑组织";
      this.dialogVisible = true;
      const { data: res } = await getDept(row.deptId);
      this.sizeForm = res.data;
      this.deptOptions = this.tableData;
      // this.sizeForm.parentId = res.data.parentId;
    },
    // 新建组织
    async add_new_btn() {
      if (!this.throttle) return;
      this.throttle = false;
      if (this.title == "新建组织") {
        const { data: res } = await addDept(this.sizeForm);
        if (res.code !== 200) {
          return this.$message({
            message: res.msg,
            type: "error"
          });
        } else {
          this.sizeForm = {
            parentId: "",
            deptNickname: "",
            deptName: "",
            orderNum: "",
            level: "",
            status: ""
          };
          this.throttle = true;
          this.dialogVisible = false;
          this.getDeptListsAjax();
          return this.$message({
            message: res.msg,
            type: "success"
          });
        }
      }
      if (this.title == "编辑组织") {
        const { data: res } = await updateDept(this.sizeForm);
        if (res.code !== 200) {
          return this.$message({
            message: res.msg,
            type: "error"
          });
        } else {
          this.sizeForm = {
            parentId: "",
            deptNickname: "",
            deptName: "",
            orderNum: "",
            level: "",
            status: ""
          };
          this.throttle = true;
          this.dialogVisible = false;
          this.getDeptListsAjax();
          return this.$message({
            message: res.msg,
            type: "success"
          });
        }
      }
    },
    // 新建组织弹窗确认和取消
    handleClose(done) {
      this.$confirm("确认关闭？")
        .then(_ => {
          done();
          this.sizeForm = {
            parentId: "",
            deptNickname: "",
            deptName: "",
            orderNum: "",
            level: "",
            status: ""
          };
          this.dialogVisible = false;
        })
        .catch(_ => {});
    },
    // 删除组织
    Delete(e) {
      this.open(e);
    },
    open(e) {
      this.$confirm(`是否确认删除名称为"${e.deptName}"的数据项？`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",

        type: "warning"
      })
        .then(async () => {
          const { data: res } = await DeptDeleteAjax(e.deptId);
          if (res.code !== 200)
            return this.$message({
              type: "error",
              message: res.msg
            });
          this.$message({
            type: "success",
            message: "删除成功!"
          });
          this.getDeptListsAjax();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除"
          });
        });
    },

    // 修改开关状态
    switch_value_btn(row) {
      let text = row.status === "0" ? "显示" : "隐藏";
      this.$confirm(
        '确认要"' + text + '""' + row.deptName + '"菜单吗?',
        "警告",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }
      )
        .then(async () => {
          const { data: res } = await DeptchangeStatus({
            deptId: row.deptId,
            status: row.status,
            orderNum: row.orderNum,
            deptName: row.deptName
          });
          if (res.code !== 200) {
            row.status = row.status === "0" ? "1" : "0";
            return this.$message({
              type: "error",
              message: res.msg
            });
          }
          this.$message({
            type: "success",
            message: res.msg
          });
          this.getDeptListsAjax();
        })
        .catch(() => {
          row.status = row.status === "0" ? "1" : "0";
        });
    },
    cancelDataScope() {
      this.dialogVisible = false;
      this.sizeForm = {
        parentId: "",
        deptNickname: "",
        deptName: "",
        orderNum: "",
        level: "0",
        status: "0"
      };
    }
  }
};
</script>

<style lang="less" scoped>
.department_title {
  width: 72px;
  height: 24px;
  font-size: 18px;
  line-height: 24px;
  color: #171a1e;
  margin-bottom: 20px;
}
/deep/.demo-form-inline {
  .el-input__inner {
    width: 200px;
    height: 36px;
    font-size: 14px;
  }
  .left_margin {
    margin-left: 26px;
  }
  .inquire {
    width: 72px;
    height: 36px;
    margin-top: 2px;
    margin-left: -12px;
  }
  .el-button + .el-button {
    margin-left: 24px;
    width: 72px;
    height: 36px;
    background: #f6b439;
    border: 1px solid #f6b439;
  }
}
.newly_built {
  margin-top: 18px;
  margin-bottom: 20px;
  .newly_built_btn {
    width: 108px;
    height: 36px;
    text-align: center;
    padding: 0;
    background-color: #f6b439;
    border: 1px solid #f6b439;
  }
}
.operation_right {
  margin-right: 20px;
}

/deep/.el-table th {
  text-align: center;
  background-color: #f2f2f2;
}
/deep/.el-table th:nth-child(1) {
  text-align: left;
}

/deep/ .el-table__row td {
  padding: 4px 0;
  text-align: center;
}
/deep/.el-table__row td:nth-child(1) {
  text-align: left;
}

.dialog-footer {
  .add_new_btn {
    background-color: #f6b439;
    border: 1px solid #f6b439;
  }
  .cancel {
    background: #f2f2f2;
    border: 1px solid #e1e1e1;
  }
}
/deep/.el-dialog__header {
  .el-dialog__title {
    font-weight: normal;
  }
}
/deep/.el-form-item--mini .el-form-item__label {
  font-weight: normal;
  font-size: 16px;
}
/deep/.el-dialog {
  border-radius: 10px;
  padding: 10px 16px;
  .el-dialog__headerbtn {
    top: 36px;
  }
  .el-dialog__headerbtn .el-dialog__close {
    color: #000;
  }
}
/deep/.el-input--mini .el-input__inner {
  height: 32px;
  line-height: 36px;
  font-size: 16px;
}
.el-button + .el-button {
  margin-left: 0;
}
/deep/ .el-date-editor .el-range__close-icon {
  line-height: 30px;
}
/deep/.el-date-editor .el-range-separator {
  line-height: 28px;
}
/deep/.el-radio__input.is-checked .el-radio__inner {
  border-color: #f6b439;
  background: #f6b439;
  width: 24px;
  height: 24px;
}
/deep/.el-radio__label {
  font-size: 16px;
}
/deep/.el-radio__input.is-checked + .el-radio__label {
  color: #f6b439;
}
/deep/.el-radio__inner {
  width: 24px;
  height: 24px;
}
/deep/.el-radio__inner::after {
  width: 10px;
  height: 10px;
}
.el-dialog__footer {
  button {
    text-align: center;
    line-height: 13px;
    width: 72px;
    height: 36px;
  }
}
.el-button + .el-button {
  margin-left: 24px;
}
</style>
